import {
    // HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
}